import { QueryClient, QueryClientProvider } from "react-query";
import { ToastContainer } from "react-toastify";

import Routers from "./Route";
import AnimationThemeProvider from "./_helper/AnimationTheme/AnimationThemeProvider";
import CustomizerProvider from "./_helper/Customizer/CustomizerProvider";
import "./axios/global";

import { LoadScript } from "@react-google-maps/api";
import "react-toastify/dist/ReactToastify.css";
import AuthProvider from "./_helper/auth/AuthProvider";
import HomeProvider from "./_helper/home/homeProvider";
import PermissionsProvider from "./_helper/permissions/permissionsProvider";
import LoadingSpinner from "./Components/UI/spinner";
import Loader from "./Layout/Loader";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // staleTime: 5 * 60 * 1000,
      retry: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,

      onError: (error) => {
        if (error.response) {
          const { status, data } = error.response;
          const message = data?.message || "An error occurred";

          switch (status) {
            case 400:
            case 403:
            case 404:
              return message;
            case 401:
              if (!window.location.pathname.includes("/login")) {
                localStorage.clear();
                window.location.href = `${process.env.PUBLIC_URL}/login`;
              }
              break;
            case 500:
              return data?.error || "Internal Server Error";
            default:
              return message;
          }
        }
      },
    },
  },
});
const App = () => {
  return (
    <div className="App">
      <LoadScript
        googleMapsApiKey="AIzaSyB0XkqwcY-2ZCGTVuKJvMAip3oc4j3RVgU"
        loadingElement={<Loader/>}
        libraries={["drawing", "places" ,"geometry"]}
        onLoad={() => console.log("Maps API has loaded.")}
      >
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <PermissionsProvider>
            <HomeProvider>
              <CustomizerProvider>
                <AnimationThemeProvider>
                  <Routers />
                  <ToastContainer />
                </AnimationThemeProvider>
              </CustomizerProvider>
            </HomeProvider>
            </PermissionsProvider>
          </AuthProvider>
        </QueryClientProvider>
      </LoadScript>
    </div>
  );
};

export default App;
